import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

export const auth: Dictionnaire['auth'] = {
  erreurs: {
    identifiants: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    emailInvalide: 'عنوان بريد إلكتروني غير صالح',
    compteExiste: 'يوجد حساب بهذا البريد الإلكتروني',
    motDePasseFaible: 'كلمة المرور ضعيفة جدًا',
    tropDeTentatives: 'محاولات كثيرة، أعد المحاولة بعد بضع دقائق',
    reseau: 'تعذّر الاتصال، تحقّق من الشبكة',
    inattendue: 'حدث خطأ ما، أعد المحاولة بعد قليل',
    parEmail: 'سجّل الدخول بعنوان بريدك الإلكتروني',
    age: 'Sirocco مخصّص لمن هم في السادسة عشرة فما فوق',
    pseudoPris: 'اسم المستخدم هذا مأخوذ',
    sessionExpiree: 'انتهت جلستك، سجّل الدخول من جديد',
    motDePasseActuel: 'كلمة المرور الحالية غير صحيحة',
    sansProfil: 'ليس لهذا الحساب ملف في Sirocco بعد. تواصل معنا إذا استمرت المشكلة.',
    connexion: 'تعذّر تسجيل الدخول',
  },
  champs: {
    email: 'البريد الإلكتروني',
    exempleEmail: 'you@example.com',
    motDePasse: 'كلمة المرور',
    retourConnexion: 'العودة إلى تسجيل الدخول',
  },
  action: {
    incomplet: 'هذا الرابط غير مكتمل.',
    expireNouveau: 'انتهت صلاحية هذا الرابط أو سبق استخدامه. اطلب رابطًا جديدًا.',
    expire: 'انتهت صلاحية هذا الرابط أو سبق استخدامه.',
    sixCaracteres: 'ستة أحرف على الأقل.',
    pasChange: 'تعذّر تغيير كلمة المرور. ربما انتهت صلاحية الرابط.',
    titreChange: 'تم تغيير كلمة المرور',
    titreNouveau: 'كلمة مرور جديدة',
    titreRetablie: 'تمت استعادة العنوان',
    titreConfirmee: 'تم تأكيد العنوان',
    unInstant: 'لحظة',
    nouveau: 'كلمة مرور جديدة',
    changer: 'تغيير كلمة المرور',
    connecteToi: 'يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
    bienvenue: 'حسابك جاهز. أهلًا بك.',
    ouvrir: 'فتح Sirocco',
    continuerSite: 'المتابعة على الموقع',
    pour: { avant: 'اختر كلمة مرور جديدة لـ', apres: '.' },
  },
  spot: {
    impossible: 'تعذّر الانضمام إلى هذا الخادم',
    publics: 'خوادم عامة',
    prives: 'خوادم خاصة',
    bientot: 'قريبًا',
    tuEsMembre: 'أنت عضو في هذا الخادم',
    membre: 'عضو في هذا الخادم',
    badgePrive: 'خاص',
    reserve: 'للأعضاء فقط',
    rechercher: 'ابحث عن مدينة أو منطقة…',
    rechercherLabel: 'ابحث عن مدينة أو منطقة',
    accesReserve: 'للأعضاء فقط',
    rejoindre: 'الانضمام إلى هذا الخادم',
    membres: (n: number) => compte(n, 'عضو واحد', 'عضوان', 'أعضاء', 'عضوًا'),
    aucun: (recherche: string) => `لا يوجد خادم يطابق «${recherche}»`,
    prive: (nom: string) => `${nom} خادم خاص: لا يدخله إلا أعضاؤه.`,
  },
  confirmer: {
    titre: 'أكّد عنوانك',
    renvoye: 'أُعيد إرسال الرسالة.',
    patiente: 'أُرسلت رسالة للتو. انتظر دقيقة قبل أن تطلب أخرى، وتحقّق من مجلد الرسائل غير المرغوب فيها.',
    trop: 'طلبت رسائل كثيرة اليوم. حاول مجددًا غدًا، أو تحقّق من مجلد الرسائل غير المرغوب فيها.',
    echec: 'تعذّر إرسال الرسالة. أعد المحاولة.',
    renvoyer: 'إعادة إرسال الرسالة',
    deconnecter: 'تسجيل الخروج',
    envoye: {
      avant: 'أُرسلت رسالة تأكيد إلى',
      apres: '. اضغط على الرابط الذي فيها للدخول إلى التطبيق.',
    },
  },
  oubli: {
    impossible: 'تعذّر الإرسال',
    titre: 'كلمة المرور',
    consigne: 'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة التعيين.',
    envoyer: 'إرسال الرابط',
    envoye: (email: string) => `إذا كان هناك حساب لـ ${email}، فالرسالة في طريقها إليك.`,
  },
  connexion: {
    impossible: 'تعذّر تسجيل الدخول',
    oublie: 'نسيت كلمة المرور؟',
    seConnecter: 'تسجيل الدخول',
    nouveau: 'جديد على Sirocco؟',
    inscrire: 'إنشاء حساب',
  },
  personnaliser: {
    photoImpossible: 'تعذّر حفظ الصورة',
    impossible: 'تعذّر الحفظ',
    titre: 'خصّص ملفك الشخصي',
    choisirPhoto: 'اختيار صورة الملف الشخصي',
    bio: 'نبذة',
    bioExemple: 'ماذا تفعل هنا، وعمّا تبحث، وأين كنت تعيش من قبل…',
    continuer: 'متابعة',
  },
  inscription: {
    regles: {
      huit: '8 أحرف على الأقل',
      casse: 'أحرف كبيرة وصغيرة',
      chiffre: 'رقم أو رمز خاص واحد على الأقل',
    },
    manque: {
      prenom: 'أدخل اسمك الأول',
      nom: 'أدخل اسم العائلة',
      pseudo: 'اختر اسم مستخدم',
      email: 'أدخل بريدك الإلكتروني',
      motDePasse: 'اختر كلمة مرور',
      naissance: 'أدخل تاريخ ميلادك',
    },
    naissanceInvalide: 'تاريخ ميلاد غير صالح',
    conditions: 'يجب أن توافق على شروط الاستخدام',
    impossible: 'تعذّر إنشاء الحساب',
    titre: 'إنشاء حساب',
    dejaInscrit: 'لديك حساب؟',
    seConnecter: 'تسجيل الدخول',
    prenom: 'الاسم الأول',
    nom: 'اسم العائلة',
    pseudo: 'اسم المستخدم',
    pseudoExemple: 'مثال: martin.pecheur',
    naissance: 'تاريخ الميلاد',
    accepteLabel: 'أوافق على شروط استخدام Sirocco وسياسة الخصوصية',
    accepte: {
      debut: 'أوافق على',
      cgu: 'شروط الاستخدام',
      et: 'و',
      confidentialite: 'سياسة الخصوصية',
      fin: 'الخاصة بـ Sirocco.',
    },
    langues: 'اللغات التي تتحدثها',
    languesAide: 'تظهر الخرجات بلغاتك أولًا في القائمة. يمكنك تغييرها من ملفك الشخصي.',
    jeMInscris: 'إنشاء حسابي',
  },
};
